<section class="landscaper">

  <h2 id="architect-title" class="container">Arquiteto
    <span>{{data.landscaper.name}}</span>
  </h2>

  <ul class="scrollable">
    <li *ngFor="let item of data.landscaper.realties">
      <figure>
        <img [src]="item.preview_image" alt="">
      </figure>
      <p>Apartamento</p>
      <h4>a partir de R$ {{item.price | number}}</h4>
      <p>{{item.title}}</p>
      <p class="address">
        {{item.address.street_type}} {{item.address.street}}, {{item.address.number}}
        <br>{{item.address.neighborhood}}, {{item.address.city}}
      </p>

      <ul class="icons">
        <li class="item" *ngFor="let item of data.details">
          <img src="/assets/svgs/{{item.icon}}.svg" [alt]="item.title">
          {{item.value}}
        </li>
      </ul>

    </li>
  </ul>
  
</section>